import { ToastProvider } from '@vizit/atoms';
import { AuthProvider } from '@vizit/auth';
import { UploadQueueProvider } from '@vizit/organisms';
import { AnalyticsProvider } from './analytics';
import { CubeAnalytics } from './init/cube/cube-analytics-init';
import { initializeFeatureFlags } from './init/feature-flags/feature-flags-init';
import { RouterProvider } from './router';

// Initialize feature flags (LaunchDarkly or fallback)
const FeatureFlagProvider = initializeFeatureFlags();

/**
 * The root component of the application.
 *
 * This component is responsible for providing the `AuthProvider` and `RouterProvider`
 * to the application. If you need to add additional providers, you can do so inside
 * `RouterProvider` so it is available inside the router context.
 *
 * @returns The root component of the application.
 */
function App() {
  return (
    <FeatureFlagProvider>
      <AuthProvider>
        <AnalyticsProvider>
          <ToastProvider>
            <UploadQueueProvider>
              <CubeAnalytics>
                <RouterProvider />
              </CubeAnalytics>
            </UploadQueueProvider>
          </ToastProvider>
        </AnalyticsProvider>
      </AuthProvider>
    </FeatureFlagProvider>
  );
}

export default App;
